import {
  React,
  Component,
  helpers
} from 'imports/CommonImports';

import {AlertDialog} from 'imports/DesignImports';

import {ContentClearIcon} from 'imports/IconsImports';

import {
  Paper,
  TextField,
  SelectField,
  MenuItem,
  IconButton,
} from 'material-ui';

const styles = {
  editContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Lato',
    paddingBottom: '25px',
    marginBottom: '15px',
    backgroundColor: '#fbfbfb',
  },
  fieldsContainer: {
    display: 'flex',
    paddingRight: '15px'
  },
  fieldContainer: {
    minWidth: '25%',
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    margin: '0px 15px',
  },
  field:{
    fontFamily: 'Lato',
    fontStyle: 'italic',
    paddingLeft: '10px',
    paddingRight: '0',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxHeight: '25px'
  },
  clearButton: {
    color: '#a2a5a6',
    padding: '0px',
    maxWidth: '24px',
    maxHeight: '24px',
    margin: '5px 5px 0px 0px'
  },
  clearIcon: {
    color: '#a2a5a6'
  }
}

class ManagerAdd extends Component {
  constructor(props){
    super(props);
    this.state = {
      show: true,
      area: this.props.manager ? this.props.manager.area : this.props.areas[0].name,
      otherArea: '',
      first_name: this.props.manager ? this.props.manager.first_name : '',
      last_name: this.props.manager ? this.props.manager.last_name : '',
      email: this.props.manager ? this.props.manager.email : '',
      dialogOpen: false,
      is_old: this.props.manager ? true : false,
      emailError: '',
    }
  }

  // componentWillReceiveProps(props){
  //   this.setState({
  //     area: props.manager ? props.manager.area : this.props.areas[0].name,
  //   })
  // }

  render() {
    if(!this.state.show){
      return (<div></div>);
    }
    return (
      <Paper zDepth={1} style={styles.editContainer}>
        {this.props.mandatory ?
          null :
          <div style={styles.buttonContainer}>
            <IconButton style={styles.clearButton} iconStyle={styles.clearIcon} onClick={this.state.is_old ? this.handleOpen : this.hide}>
              <ContentClearIcon/>
            </IconButton>
          </div>
        }
        <div style={styles.fieldsContainer}>
          <div style={styles.fieldContainer}>
            <div style={styles.label}>Área</div>
            <SelectField
              menuStyle={styles.field}
              labelStyle={{paddingRight: '0'}}
              name="area"
              value={this.state.area}
              disabled={this.props.mandatory}
              onChange={this.handleSelectChange}
              >
              {this.props.areas.map((area, i) => {
                return (<MenuItem key={i} value={area.name} primaryText={area.name} />)
              })}
              <MenuItem value='Otra' primaryText='Otra' styles={styles.menuItem}/>
            </SelectField>
            {this.state.area === 'Otra' &&
              <div style={styles.fieldContainer}>
                <TextField
                  hintText='Escribe aquí'
                  inputStyle={styles.field}
                  name="otherArea"
                  value={this.state.otherArea}
                  onChange={this.handleChange}
                />
              </div>
            }
          </div>
          <div style={styles.fieldContainer}>
            <div style={styles.label}>Nombre</div>
            <TextField
            inputStyle={styles.field}
            name="first_name"
            value={this.state.first_name}
            onChange={this.handleChange}
            />
            </div>
          <div style={styles.fieldContainer}>
            <div style={styles.label}>Apellidos</div>
            <TextField
            inputStyle={styles.field}
            name="last_name"
            value={this.state.last_name}
            onChange={this.handleChange}
            />
          </div>
          <div style={styles.fieldContainer}>
            <div style={styles.label}>Mail</div>
            <TextField
            inputStyle={styles.field}
            name="email"
            value={this.state.email}
            onChange={this.handleChange}
            />
          </div>
        </div>
        { this.state.dialogOpen ?
          <AlertDialog
            title='¡Atención!'
            message="¿Estás seguro que quieres eliminar a este gerente/encargado de área?"
            acceptLabel='Sí, eliminar'
            cancelLabel='No, volver'
            confirm={this.hide}
            cancel={this.handleClose}/> :
            null }
      </Paper>
    );
  }

  hide = () => {
    this.props.hide();
    this.setState({show: false});
  }

  handleChange = (event) => {
    if(event.target.name === 'email' && !helpers.validEmail(event.target.value)){
      this.setState({emailError: 'Debes ingresar un email válido'});
    }
    this.setState({[event.target.name]: event.target.value});
    this.props.handleChange(event);
  }

  handleSelectChange = (event, index, value) => {
    this.props.handleSelectChange(event, index, value);
    this.setState({area: value, otherArea: ''})
  }

  handleOpen = () => {
    this.setState({dialogOpen: true});
  };

  handleClose = () => {
    this.setState({dialogOpen: false});
  };


}

export default ManagerAdd;



// WEBPACK FOOTER //
// ./src/components/setup/ManagerAdd.js